import { render, staticRenderFns } from "./NumbersBar.vue?vue&type=template&id=6cc19e70&"
import script from "./NumbersBar.vue?vue&type=script&lang=js&"
export * from "./NumbersBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports